import { render, staticRenderFns } from "./IntelligentWarehous.vue?vue&type=template&id=be4e5064&scoped=true&"
import script from "./IntelligentWarehous.vue?vue&type=script&lang=js&"
export * from "./IntelligentWarehous.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentWarehous.vue?vue&type=style&index=0&id=be4e5064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4e5064",
  null
  
)

export default component.exports